import { BlocksFooter } from 'blocks-nextjs/blocks-web-components/components/footer/footer';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatFooter = createComponent({ react: React, tagName: 'cat-footer', elementClass: BlocksFooter });
